import {priority} from '@priority-software/priority-proto-api/lib';
import texts from '../../texts';

export type Headers = {
    title: string;
    help: null | string;
};

export const xAxisData = [
    {value: priority.netitems.nrest.RepColAxisMode.RepColAxisMode_None, label: ''},
    {value: priority.netitems.nrest.RepColAxisMode.RepColAxisMode_X, label: texts.xAxisItem},
    {value: priority.netitems.nrest.RepColAxisMode.RepColAxisMode_OrderBy, label: texts.oAxisItem}
];
export const dateColumnTypes = [
    priority.netitems.form.ColumnType.Date8,
    priority.netitems.form.ColumnType.Date10,
    priority.netitems.form.ColumnType.Date14
];

export const CELL_HEIGHT = 41;
export const MARGIN_OFFSET_TO_BOTTOM = 114;

type HeaderColumn = {
    isDataChart: boolean;
};

export const buildTableHeaderCols = ({isDataChart = false}: HeaderColumn) => {
    let headerColumns;

    if (isDataChart) {
        headerColumns = [
            {
                title: texts.fieldsTableNewName,
                help: null
            },
            {
                title: texts.fieldsTableInput,
                help: texts.inputColumnHelp
            },
            {
                title: texts.fieldsTableSort,
                help: texts.sortHelp
            },
            {
                title: texts.fieldsTableGroup,
                help: texts.groupHelp
            },
            {
                title: texts.fieldsTableFunction,
                help: texts.functionHelp
            },
            {
                title: texts.fieldsTableFormat,
                help: texts.formatHelp
            },
            {
                title: texts.fieldsTableWidth,
                help: texts.widthHelp
            },
            {
                title: texts.fieldsTableShowMine,
                help: texts.showMineHelp
            }
        ];
    } else {
        headerColumns = [
            {
                title: texts.fieldsTableNewName,
                help: null
            },
            {
                title: texts.fieldsTableInput,
                help: texts.inputColumnHelp
            },
            {
                title: texts.fieldsTableSort,
                help: texts.sortHelp
            },
            {
                title: texts.fieldsTableGroup,
                help: texts.groupHelp
            },
            {
                title: texts.fieldsTableGroupTitle,
                help: texts.groupTitle
            },
            {
                title: texts.fieldsTableFunction,
                help: texts.functionHelp
            },
            {
                title: texts.fieldsTablegroupFunction,
                help: texts.fieldsTableGroupFunctionHelp
            },
            {
                title: texts.fieldsTableFormat,
                help: texts.formatHelp
            },
            {
                title: texts.fieldsTableWidth,
                help: texts.widthHelp
            },
            {
                title: texts.fieldsTableXaxis,
                help: texts.axisHelp
            },
            {
                title: texts.fieldsTableShowMine,
                help: texts.showMineHelp
            }
        ];
    }
    return headerColumns;
};

export const functionsOptionsExpressionsDialog = () => [
    {
        title: 'REALQUANT(number)',
        description: texts.convertDecimal,
        value: 'REALQUANT(number))'
    },
    {
        title: 'MAXOP(number1, number2)',
        description: texts.maximum,
        value: 'MAXOP(number1, number2)'
    },
    {
        title: 'MINOP(number1, number2)',
        description: texts.minimum,
        value: 'MINOP(number1, number2)'
    },
    {
        title: 'ROUND(number)',
        description: texts.roundToWhole,
        value: 'ROUND(number)'
    },
    {
        title: 'ABS(number)',
        description: texts.absoluteValueInt,
        value: 'ABS(number)'
    },
    {
        title: 'ABSR(number)',
        description: texts.absoluteValueReal,
        value: 'ABSR(number)'
    }
];
